Object.defineProperty(exports,"__esModule",{value:true});var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);

var _portal=require("../victory-portal/portal");var _portal2=_interopRequireDefault(_portal);
var _index=require("../victory-util/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

VictoryContainer=function(_React$Component){_inherits(VictoryContainer,_React$Component);





































function VictoryContainer(props){_classCallCheck(this,VictoryContainer);var _this=_possibleConstructorReturn(this,(VictoryContainer.__proto__||Object.getPrototypeOf(VictoryContainer)).call(this,
props));
_this.getTimer=_this.getTimer.bind(_this);return _this;
}_createClass(VictoryContainer,[{key:"componentWillMount",value:function componentWillMount()

{var _this2=this;
this.savePortalRef=function(portal){return _this2.portalRef=portal;};
this.portalUpdate=function(key,el){return _this2.portalRef.portalUpdate(key,el);};
this.portalRegister=function(){return _this2.portalRef.portalRegister();};
this.portalDeregister=function(key){return _this2.portalRef.portalDeregister(key);};
}},{key:"componentWillUnmount",value:function componentWillUnmount()

{
if(!this.context.getTimer){
this.getTimer().stop();
}
}},{key:"getChildContext",value:function getChildContext()

{
return this.props.standalone!==false?
{
portalUpdate:this.portalUpdate,
portalRegister:this.portalRegister,
portalDeregister:this.portalDeregister,
getTimer:this.getTimer}:
{};
}},{key:"getTimer",value:function getTimer()

{
if(this.context.getTimer){
return this.context.getTimer();
}
if(!this.timer){
this.timer=new _index.Timer();
}
return this.timer;
}},{key:"getChildren",value:function getChildren(


props){
return props.children;
}},{key:"renderContainer",value:function renderContainer(


props,svgProps,style){var
title=props.title,desc=props.desc,portalComponent=props.portalComponent,className=props.className,standalone=props.standalone;
return standalone!==false?

_react2.default.createElement("svg",_extends({},svgProps,{style:style,className:className}),
_react2.default.createElement("title",{id:"title"},title),
_react2.default.createElement("desc",{id:"desc"},desc),
this.getChildren(props),
_react2.default.cloneElement(portalComponent,{ref:this.savePortalRef})):



_react2.default.createElement("g",_extends({},svgProps,{style:style,className:className}),
this.getChildren(props));


}},{key:"render",value:function render()

{var _props=
this.props,width=_props.width,height=_props.height,responsive=_props.responsive,events=_props.events,standalone=_props.standalone;
var style=responsive?this.props.style:(0,_omit3.default)(this.props.style,["height","width"]);
var svgProps=(0,_assign3.default)(
{
width:width,height:height,
"aria-labelledby":standalone!==false?"title desc":undefined,
role:standalone!==false?"img":"presentation",
viewBox:responsive&&standalone!==false?"0 0 "+width+" "+height:undefined},

events);

return this.renderContainer(this.props,svgProps,style);
}}]);return VictoryContainer;}(_react2.default.Component);VictoryContainer.displayName="VictoryContainer";VictoryContainer.propTypes={className:_react.PropTypes.string,style:_react.PropTypes.object,height:_react.PropTypes.number,width:_react.PropTypes.number,events:_react.PropTypes.object,children:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node),_react2.default.PropTypes.node]),title:_react.PropTypes.string,desc:_react.PropTypes.string,portalComponent:_react.PropTypes.element,responsive:_react.PropTypes.bool,standalone:_react.PropTypes.bool};VictoryContainer.defaultProps={title:"Victory Chart",desc:"",portalComponent:_react2.default.createElement(_portal2.default,null),responsive:true};VictoryContainer.contextTypes={getTimer:_react2.default.PropTypes.func};VictoryContainer.childContextTypes={portalUpdate:_react2.default.PropTypes.func,portalRegister:_react2.default.PropTypes.func,portalDeregister:_react2.default.PropTypes.func,getTimer:_react2.default.PropTypes.func};exports.default=VictoryContainer;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-container/victory-container.js
// module id = 525
// module chunks = 0